export enum RouteTitle {
  STATISTICS = "statistics:title",
  RESERVATIONS = "reservations:title",
  RULE_GROUPS = "ruleGroups:bookingRules",
  EMPLOYEES = "employees:title",
  TENANTS = "tenants:title",
  PARKING_SPOTS = `resources:resource.parkingSpots`,
  DESK = `resources:resource.desk`,
  SITES_DETAILS = "sites:siteDetails",
  ORGANIZATION_DETAILS = "organizationDetails:title",
  ORGANIZATION_ADMINS = "organizationAdmins:title",
  ISSUES = "issues:title",
  BLACKLIST = "blacklist:title",
  SETTINGS = "settings:title",
  BILLING = "billing:title",
  SITE_MANAGEMENT = "siteManagement:title",
  CHARGING_SPOTS = "evChargers:chargingSpots.title",
  RESERVATIONS_SECURITY = "reservationsSecurity:title",
  PASSWORD = "settings:tabs.password",
  CONTACT_FORM = "settings:contactForm",
  SYSTEM_MESSAGES = "systemMessages:common.title",
}

export enum SidebarRouteTitle {
  PARKING_SETUP = "routes:parkingSetup",
  DATA_AND_ISSUE = "routes:dataAndIssues",
  SUPPORT_AND_SETTINGS = "routes:supportAndSettings",
  PARKING = "routes:parking",
}

export enum SubRouteTitle {}
